PJQ.views.productionQuantities.ProductionQuantityEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-production-quantity-edit'),
        width: '95%',
        maxWidth: 600,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-save': 'saveProductionQuantity',
        'click .btn-delete': 'deleteProductionQuantity',
        'click .btn-add-installed-quantities': 'addInstalledQuantities'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.model == null) {
            this.model = new PJQ.models.productionQuantities.ProductionQuantity({
                projectId: PJQ.app.session.project.id,
                quantity: 0,
                description: ''
            });
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.subJobs = await this.options.project.fetchSubJobs();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canAdd = this.options.project.permissions.hasPermission('productionQuantities.canAdd');
        this.options.canEdit = this.options.project.permissions.hasPermission('productionQuantities.canEdit');
        this.options.isAdmin = this.options.project.permissions.hasPermission('productionQuantities.isAdmin');
        this.options.canDelete = this.options.isAdmin;

        if (!this.isFetched || this.model.isNew()) {
            return;
        }
    },
    renderData: function () {
        return {
            model: this.model,
            canAdd: this.options.canAdd,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ]
        });

        this.costCodePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-cost-code'),
            defaultValue: this.model.get('costCodeId'),
            noneSelectedText: 'Select Cost Code',
            isDisabled: _.size(this.costCodes.models) === 0 || !this.model.isNew() || !this.options.canEdit,
            isMultiple: false,
            isIntChoices: true,
            isLiveSearch: true,
            onChange: _.bind(function (value) {
                value = value > 0 ? value : null;
                this.model.set('costCodeId', value);
            }, this)
        });
        this.populateCostCodePicker();

        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-quantity'), 2);

        this.unitOfMeasureSelector = new PJQ.inputs.Selectpicker({
            el: this.$('.select-unit-of-measure'),
            defaultValue: this.model.get('unitId'),
            isDisabled: !this.model.isNew() || !this.options.canEdit,
            choices: _.map(this.unitsOfMeasure.models, function (unit) {
                return {
                    name: unit.get('name'),
                    id: unit.id
                };
            }),
            onChange: _.bind(function (value) {
                this.model.set('unitId', value);
            }, this),
            isIntChoices: true,
            hideDisabled: true
        });

        this.dataTable = new PJQ.views.productionQuantities.InstalledQuantitiesDatatable({
            el: this.$('.installed-quantities-data'),
            rowId: "cid",
            project: this.options.project,
            data: this.model.installedQuantities.models,
            isAdmin: false,
            order: [2, 'desc'],
            canAdd: false,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    isAdmin: this.options.isAdmin,
                    canAdd: this.options.canAdd,
                    model: this.model
                };
            }, this)
        });
    },
    addInstalledQuantities: function () {
        new PJQ.views.productionQuantities.InstalledQuantitiesAddModal({
            project: this.options.project,
            productionQuantityId: this.model.id,
            onSave: (newQuantities) => {
                this.model.installedQuantities?.add(newQuantities);
                this.dataTable.render();
            }
        });
    },
    populateCostCodePicker: function () {
        // Group the cost codes by their Sub Job
        let groupedCostCodes = _.groupBy(this.costCodes.models, function (costCode) {
            return costCode.get('subJobId');
        });

        // Convert groupedCostCodes to the format that updateChoices expects
        let choices = _.map(groupedCostCodes, function (costCodes, subJobId) {
            let subJob = _.find(this.subJobs.models, function (subJob) {
                return subJob.id === parseInt(subJobId);
            }, this);
            return {
                name: subJob != null ? subJob.get('name') : 'No Sub Job',
                choices: _.map(costCodes, function (costCode) {
                    return {
                        id: costCode.id,
                        name: costCode.get('name')
                    };
                })
            };
        }, this);

        if (this.costCodePicker != null) {
            this.costCodePicker.updateChoices(choices);
            this.costCodePicker.setValue(this.model.get('costCodeIds') ? this.model.get('costCodeIds') : []);
            if (_.size(this.costCodes.models) > 0 && this.options.canEdit && this.model.isNew()) {
                this.costCodePicker.enable();
            } else {
                this.costCodePicker.disable();
            }
            this.costCodePicker.render();
        }
    },
    saveProductionQuantity: function () {
        let isNew = this.model.isNew();
        this.save(() => {
            PJQ.notifications.notify.successNotify({
                message: 'Production Quantity saved successfully'
            });

            if (!isNew) {
                this.removeModal();
            }
        });
    },
    validate: function () {
        let isValid = true;

        if (this.model.get('costCodeId') == null) {
            this.costCodePicker.showError("Cost Code is required");
            isValid = false;
        }

        if (this.model.get('unitId') == null) {
            this.unitOfMeasureSelector.showError("Unit of Measure is required");
            isValid = false;
        }

        return isValid;
    },
    save: function (callback) {
        if (!this.validate())
            return;

        this.model.save(null, {
            success: _.bind(function () {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('productionQuantityChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this)
        });
    },
    deleteProductionQuantity: function () {
        let productionQuantityId = this.model.id
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this Production Quantity?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Production Quantity deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(productionQuantityId);

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveProductionQuantity();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});